import { useState, useEffect } from "react";
import Panel from "../Panel/Panel";
import { isAuth } from "../../services/requestServices";
import { wrapAuthData } from "../AuthData/AuthData";
import appSettings from "../../settings/appSettings";
const shimmerProps = { height: "0px" };
const requires = ["child"];

export function Login(props) {
  const { requiredData } = props;
  const { child } = requiredData;
  const [logIn, setLogIn] = useState(true);
  useEffect(() => {
    async function setLoggedIn() {
      const isLoggedIn = await isAuth();
      setLogIn(isLoggedIn);
    }
    setLoggedIn();
  }, []);

  function handleLogin(e) {
    e.preventDefault();
    const encodedCurrentURL = encodeURIComponent(window.location.href);
    const defaultLoginUrl = `https://donate.worldvision.org/customer/account/login?redirect_to=${encodedCurrentURL}`; //Defaulting to Prod
    let { loginRedirectUrl } = appSettings;

    if (!loginRedirectUrl) {
      loginRedirectUrl = defaultLoginUrl;
    } else {
      loginRedirectUrl = loginRedirectUrl + `?ID=${child.identifier}`;
    }
    window.location.replace(loginRedirectUrl);
    return null;
  }

  return !logIn ? (
    <Panel classList="panel__login">
      <h3 className="eta">Sign in to connect with {child.givenName}</h3>
      <div className="panel__login__text">
        If you want to email, give a gift, or learn how to visit{" "}
        {child.givenName}, please sign in.
      </div>
      <a type="button" className="btn btn-ghost-orange" onClick={handleLogin}>
        Sign In
      </a>
    </Panel>
  ) : (
    ""
  );
}

export default wrapAuthData(Login, { shimmerProps, requires, name: "Login" });
